import React, { useState } from 'react';
import { Icon } from './Icon';

interface BulkAssignmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAssign: (assignTo: string, assignToId: string) => void;
  selectedCount: number;
}

// Mock data para agentes - en un proyecto real vendría de la API
const mockAgents = [
  { id: '3', name: 'Agente 1' },
  { id: '4', name: 'Agente 2' },
  { id: '10', name: 'Esteban Valenzuela' },
];

export const BulkAssignmentModal: React.FC<BulkAssignmentModalProps> = ({
  isOpen,
  onClose,
  onAssign,
  selectedCount
}) => {
  const [assignTo, setAssignTo] = useState('');
  const [assignToId, setAssignToId] = useState('');

  const handleSubmit = () => {
    if (assignToId) {
      onAssign(assignTo, assignToId);
      setAssignTo('');
      setAssignToId('');
      onClose();
    }
  };

  const handleAgentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedAgent = mockAgents.find(a => a.id === e.target.value);
    setAssignToId(e.target.value);
    setAssignTo(selectedAgent?.name || '');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">
            Asignación Masiva
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <Icon name="x" className="w-5 h-5" />
          </button>
        </div>

        <div className="mb-4">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Se asignarán <strong>{selectedCount}</strong> registros al agente seleccionado.
          </p>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Seleccionar Agente
          </label>
          <div className="relative">
            <Icon name="chevron-down" className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
            <select
              value={assignToId}
              onChange={handleAgentChange}
              className="w-full pl-4 pr-10 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white appearance-none"
            >
              <option value="">Seleccionar agente</option>
              {mockAgents.map((agent) => (
                <option key={agent.id} value={agent.id}>
                  {agent.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 rounded-lg transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            disabled={!assignToId}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 rounded-lg transition-colors"
          >
            Asignar
          </button>
        </div>
      </div>
    </div>
  );
};
